import ServiceBase from "base/baseService"

export default class ClassificacaoPessoaService extends ServiceBase {

    title = "Classificação de pessoa"
    pluralTitle = "Classificação de pessoas"
    url = '/cadastro/pessoa/classificacaopessoa'
    frontUrl = '/cadastro/pessoa/classificacaopessoa'
    frontUrlList = '/cadastro/pessoa/classificacaopessoalist'
    primaryKey = 'codigo_clap'
    ignoredsSchemaConvertions = ['cod_tipe_clap']

    prepareToSave({ data }) {

        data.cod_tipe_clap = data.cod_tipe_clap?.codigo_tipe || null

        delete data.meta

        return data

    }

}
